module.exports = __webpack_public_path__ + "media/images/email/rewards/useek_logo-2fc282cc95075fa0165b55d1465c7766.png";